export type BuildReviewStatus =
  | "Needs Review"
  | "Approved"
  | "Revision Required"
  | "Awaiting Sales Confirmation"
  | "Awaiting Customer Signature"
  | "Final Review"
  | "On Hold — Sales Action Required"
  | "Resubmitted for Review";

export type RevisionReason =
  | "measurement_mismatch"
  | "wrong_material"
  | "missing_component"
  | "scope_unclear"
  | "photo_insufficient"
  | "custom_issue";

export const REVISION_REASON_LABELS: Record<RevisionReason, string> = {
  measurement_mismatch: "Measurement Mismatch",
  wrong_material: "Wrong Material Sold",
  missing_component: "Missing Component",
  scope_unclear: "Scope Unclear",
  photo_insufficient: "Photo Insufficient",
  custom_issue: "Custom Issue",
};

export interface BuildReviewEvent {
  id: string;
  jobId: string;
  action: BuildReviewAction;
  timestamp: string;
  performedBy: string;
  notes?: string;
  revisionNotes?: string;
  revisionReason?: RevisionReason;
  materialChanges?: string;
}

export type BuildReviewAction =
  | "submitted_for_review"
  | "approved"
  | "revision_requested"
  | "sent_to_sales"
  | "sales_confirmed"
  | "sales_resubmitted"
  | "change_order_created"
  | "customer_signed"
  | "final_approved";

export function deriveBuildReviewStatus(events: BuildReviewEvent[]): BuildReviewStatus {
  if (events.length === 0) return "Needs Review";
  const last = events[events.length - 1];
  switch (last.action) {
    case "approved":
    case "final_approved":
      return "Approved";
    case "revision_requested":
      return "On Hold — Sales Action Required";
    case "sent_to_sales":
      return "Awaiting Sales Confirmation";
    case "sales_confirmed":
      return "Awaiting Sales Confirmation";
    case "sales_resubmitted":
      return "Resubmitted for Review";
    case "change_order_created":
      return "Awaiting Customer Signature";
    case "customer_signed":
      return "Final Review";
    default:
      return "Needs Review";
  }
}

// Backward-compatible aliases
export type BathReviewStatus = BuildReviewStatus;
export type BathReviewEvent = BuildReviewEvent;
export type BathReviewAction = BuildReviewAction;
export const deriveBathReviewStatus = deriveBuildReviewStatus;
